import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    padding: theme.spacing(2, 2, 1, 0)
  },
  filtersGroup: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0
  },
  actionsGroup: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0
  },
  measurementRow: {
    position: 'absolute',
    visibility: 'hidden',
    pointerEvents: 'none',
    whiteSpace: 'nowrap'
  },
  chipRoot: {
    maxWidth: '80ch',
    minWidth: 0
  },
  chipLabel: {
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));
